import { progressActionTypes } from './constants';

import type { ProgressState } from '../types';

const initialState: ProgressState = {
	loading: false,
	activity: {},
	subjects: [],
	openInfoModal: null,
	openProgressOnboardingModal: null,
	progressDetails: {
		id: 0,
		name: '',
		image: '',
		topic_levels: [],
	},
};

export default function progressReducer(
	state = initialState,
	action: { type: string; payload?: Record<string, unknown> },
): ProgressState {
	const { type, payload } = action;
	const { activity, subjects, openModal, progressDetails } = payload || {};

	switch (type) {
		case progressActionTypes.GET_PROGRESS_OVERVIEW_REQUEST:
			return {
				...state,
				loading: true,
			};

		case progressActionTypes.GET_PROGRESS_OVERVIEW_SUCCESS:
			return {
				...state,
				loading: false,
				activity: activity as ProgressState['activity'],
				subjects: subjects as ProgressState['subjects'],
			};

		case progressActionTypes.GET_PROGRESS_OVERVIEW_ERROR:
			return {
				...state,
				loading: false,
			};

		case progressActionTypes.GET_PROGRESS_DETAILS_REQUEST:
			return {
				...state,
				loading: true,
			};

		case progressActionTypes.GET_PROGRESS_DETAILS_SUCCESS:
			return {
				...state,
				loading: false,
				progressDetails: progressDetails as ProgressState['progressDetails'],
			};

		case progressActionTypes.GET_PROGRESS_DETAILS_ERROR:
			return {
				...state,
				loading: false,
			};

		case progressActionTypes.TOGGLE_INFO_MODAL:
			return {
				...state,
				openInfoModal: openModal as boolean,
			};

		case progressActionTypes.TOGGLE_PROGRESS_ONBOARDING_MODAL:
			return {
				...state,
				openProgressOnboardingModal: openModal as boolean,
			};

		case progressActionTypes.CLEAR_PROGRESS_DETAILS:
			return {
				...state,
				progressDetails: initialState.progressDetails,
			};

		default:
			return state;
	}
}
